<template>
  <el-form
    ref="form"
    :model="formData"
    :rules="rules"
    label-width="110px"
    :size="defaultFormItemSize"
    label-position="right"
    @submit.native.prevent
  >
    <el-row :gutter="20" class="full-width-input">
      <!-- <el-col :span="24">
        <el-form-item label="上级菜单">
          <el-cascader :options="menuTree" v-model="parentMenuPath" :props="menuProps" placeholder="选择父菜单"
            :clearable="true" :change-on-select="true" :size="defaultFormItemSize"
            @change="onParentMenuChange" />
        </el-form-item>
      </el-col> -->
      <el-col :span="24">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input
            v-model="formData.menuName"
            placeholder="菜单名称"
            clearable
            maxlength="30"
          />
        </el-form-item>
      </el-col>
      <!-- <el-col :span="24">
        <el-form-item label="菜单类型" prop="menuType">
          <el-select v-model="formData.menuType" :disabled="isEdit" placeholder="菜单类型" >
            <el-option v-for="item in getValidMenuType" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
      </el-col> -->
      <el-col :span="24">
        <el-form-item label="显示顺序" prop="showOrder">
          <el-input-number
            v-model="formData.showOrder"
            controls-position="right"
            :min="1"
            :max="99999"
            placeholder="请输入显示顺序"
          ></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="菜单路由">
          <el-input
            v-model="formData.formRouterName"
            placeholder="菜单路由"
            :disabled="true"
          />
        </el-form-item>
      </el-col>
      <!-- <el-col :span="24">
        <el-form-item label="菜单图标" prop="icon">
          <icon-select v-model="formData.icon" :height="28" />
        </el-form-item>
      </el-col> -->
    </el-row>
    <!-- 弹窗按钮 -->
    <el-row type="flex" justify="end" class="dialog-btn-layer mt20">
      <el-button :size="defaultFormItemSize" @click="onCancel(false)">取消</el-button>
      <el-button
        type="primary"
        :size="defaultFormItemSize"
        @click="onSubmit"
        :disabled="
          !(
            checkPermCodeExist('formSysMenu:fragmentSysMenu:add') ||
            checkPermCodeExist('formSysMenu:fragmentSysMenu:update')
          )
        "
      >
        确定
      </el-button>
    </el-row>
  </el-form>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {
  treeDataTranslate,
  findTreeNodePath,
  findTreeNode,
  findItemFromList,
} from "@/utils";
import { SystemController } from "@/api";
import IconSelect from "@/components/IconSelect/index.vue";

export default {
  props: {
    menuId: {
      type: String,
    },
    parentId: {
      type: String,
    },
    menuList: {
      type: Array,
      default: undefined,
    },
    rowData: {
      type: Object,
      default: undefined,
    },
  },
  components: {
    IconSelect,
  },
  data() {
    return {
      formData: {
        menuId: undefined,
        parentId: undefined,
        menuName: undefined,
        showOrder: undefined,
        menuType: undefined,
        icon: undefined,
        formRouterName: undefined,
      },
      menuProps: {
        label: "menuName",
        value: "menuId",
      },
      parentMenuType: undefined,
      parentMenuPath: [],
      menuTree: [],
      rules: {
        menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        showOrder: [{ required: true, message: "请输入菜单显示顺序", trigger: "blur" }],
        formRouterName: [
          { required: true, message: "请输入菜单路由名称", trigger: "blur" },
        ],
      },
      treeProps: {
        label: "showName",
      },
    };
  },
  mounted(){
  },
  methods: {
    onParentMenuChange(value, isInit) {
      this.parentMenuType = undefined;
      if (Array.isArray(value) && value.length > 0) {
        let node = findTreeNode(this.menuTree, value[value.length - 1], "menuId");
        if (node) this.parentMenuType = node.menuType;
      }
      // 父菜单切换后判断可用菜单类型是否改变，如果改变则清空
      if (
        !isInit &&
        this.getValidMenuType.map((item) => item.id).indexOf(this.formData.menuType) ===
          -1
      )
        this.formData.menuType = undefined;
    },
    onCancel(isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let params = {};
            params.sysMenuDto = { ...this.formData };
            if (this.parentMenuPath.length > 0) {
              params.sysMenuDto.parentId = this.parentMenuPath[
                this.parentMenuPath.length - 1
              ];
            } else {
              params.sysMenuDto.parentId = undefined;
            }
            if (this.isEdit) {
              params.sysMenuDto.onlineFormId = null;
              SystemController.updateMenu(this, params)
                .then((res) => {
                  resolve(res);
                  this.$message.success("编辑成功");
                  this.onCancel(true);
                })
                .catch((e) => {
                  reject(e);
                });
            } else {
              SystemController.addMenu(this, params)
                .then((res) => {
                  resolve(res);
                  this.$message.success("添加成功");
                  this.onCancel(true);
                })
                .catch((e) => {
                  reject(e);
                });
            }
          } else {
            reject();
          }
        });
      });
    },
    formatMenuTree() {
      this.menuTree = [];
      if (Array.isArray(this.menuList)) {
        this.menuTree = this.menuList
          .map((item) => {
            return {
              ...item,
            };
          })
          .filter((item) => {
            return (
              item.menuType !== this.SysMenuType.BUTTON &&
              item.menuId !== this.formData.menuId
            );
          });
      }
      this.menuTree = treeDataTranslate(this.menuTree, "menuId", "parentId");
    },
    initData() {
      this.formatMenuTree();
      this.parentMenuPath = findTreeNodePath(
        this.menuTree,
        this.formData.parentId,
        "menuId"
      );
      this.onParentMenuChange(this.parentMenuPath, true);
    },
  },
  computed: {
    getValidMenuType() {
      let allList = this.SysMenuType.getList();
      if (this.parentMenuType == null) {
        return allList.filter((item) => {
          return (
            [this.SysMenuType.MENU, this.SysMenuType.DIRECTORY].indexOf(item.id) !== -1
          );
        });
      } else {
        return allList.filter((item) => {
          switch (Number.parseInt(this.parentMenuType)) {
            case this.SysMenuType.DIRECTORY:
              return (
                [this.SysMenuType.MENU, this.SysMenuType.DIRECTORY].indexOf(item.id) !==
                -1
              );
            case this.SysMenuType.MENU:
              return (
                [this.SysMenuType.FRAGMENT, this.SysMenuType.BUTTON].indexOf(item.id) !==
                -1
              );
            case this.SysMenuType.FRAGMENT:
              return item.id === this.SysMenuType.BUTTON;
            default:
              return false;
          }
        });
      }
    },
    isEdit() {
      return this.formData.menuId != null;
    },
    // 判断是否新建一个目录
    isNew() {
      return this.formData.parentId == null && this.formData.menuId == null;
    },
    canEditParent() {
      return this.parentId == null;
    },
  },
  mounted() {
    if (this.rowData != null) {
      this.formData = { ...this.formData, ...this.rowData };
    }
    if (this.parentId != null) this.formData.parentId = this.parentId;
    this.initData();
  },
  watch: {},
};
</script>
